/**
 * Formats an elapsed-seconds value as `m:ss` for audio progress readouts.
 * Shared by the TTS player blocks so the two stay in step.
 */
export const formatTime = (seconds: number): string => {
  const safeSeconds = Number.isFinite(seconds) && seconds > 0 ? seconds : 0
  const mins = Math.floor(safeSeconds / 60)
  const secs = Math.floor(safeSeconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}
